import React from 'react';
import { reduxForm, FormSection } from 'redux-form';
import formNames from '../../constants/formNames';
import ContactForm from '../_Common/Forms/ContactForm';

const DistributorContact = props => (
  <FormSection name="Contact">
    <ContactForm {...props} />
  </FormSection>
);

export default reduxForm({
  form: formNames.distributor,
  destroyOnUnmount: true,
  enableReinitialize: true,
  // validate,
})(DistributorContact);
